/* @flow */

export default {
  AFFILIATE_OF_DAIMLER_AG: 'Affiliate_Of_Daimler_AG',
};
